<script>
import { VMenu } from 'vuetify/lib'

export default {
  name: 'EMenu',
  extends: VMenu,
  methods: {
    genContent() {
      const options = {
        attrs: { ...this.getScopeIdAttrs(), role: 'role' in this.$attrs ? this.$attrs.role : 'menu' },
        staticClass: 'v-menu__content',
        class: {
          'e-menu': true,
          ...this.rootThemeClasses,
          ...this.roundedClasses,
          'v-menu__content--auto': this.auto,
          'v-menu__content--fixed': this.activatorFixed,
          menuable__content__active: this.isActive,
          [this.contentClass.trim()]: true,
        },
        style: this.styles,
        directives: this.genDirectives(),
        ref: 'content',
        on: {
          click: (e) => {
            const target = e.target
            if (target.getAttribute('disabled')) return
            if (this.closeOnContentClick) this.isActive = false
          },
          keydown: this.onKeyDown,
        },
      }

      if (this.$listeners.scroll) {
        options.on = options.on || {}
        options.on.scroll = this.$listeners.scroll
      }

      if (!this.disabled && this.openOnHover) {
        options.on = options.on || {}
        options.on.mouseenter = this.mouseEnterHandler
      }

      if (this.openOnHover) {
        options.on = options.on || {}
        options.on.mouseleave = this.mouseLeaveHandler
      }

      return this.$createElement('div', options, this.getContentSlot())
    },
  },
}
</script>
